import FilterQueries from './FilterQueries';

export default FilterQueries;
